// docs/index.js — Section + topic registry
// Add a new page: create the file in topics/, import it here, add to the section.

import whatIsTradeLab     from './topics/getting-started/what-is-tradelab';
import creatingAccount    from './topics/getting-started/creating-account';
import settingUpProfile   from './topics/getting-started/setting-up-profile';
import userJourney        from './topics/getting-started/user-journey';

import dashboardOverview  from './topics/platform/dashboard-overview';
import navigation         from './topics/platform/navigation';
import virtualCapital     from './topics/platform/virtual-capital';

import riskProfileSetup   from './topics/risk-capital/risk-profile-setup';
import riskCapital        from './topics/risk-capital/virtual-capital';
import positionSizing     from './topics/risk-capital/position-sizing';

import disciplineScore    from './topics/discipline/discipline-score';
import behavioralProfile  from './topics/discipline/behavioral-profile';
import behaviorAnalytics  from './topics/discipline/behavior-analytics';

import placingAnOrder     from './topics/orders/placing-an-order';
import orderTypes         from './topics/orders/order-types';
import managingPositions  from './topics/orders/managing-positions';
import tradeHistory       from './topics/orders/trade-history';

import whatIsAct          from './topics/act/what-is-act';
import howScenariosWork   from './topics/act/how-scenarios-work';
import swingVsIntraday    from './topics/act/swing-vs-intraday';
import submittingPlan     from './topics/act/submitting-trade-plan';
import actScoring         from './topics/act/act-scoring';

import whatAreScanners    from './topics/scanners/what-are-scanners';
import swingScanners      from './topics/scanners/swing-scanners';
import intradayScanners   from './topics/scanners/intraday-scanners';
import readingScannerOutput from './topics/scanners/reading-scanner-output';

import whatIsAlgoFlows    from './topics/algo-flows/what-is-algo-flows';
import creatingStrategy   from './topics/algo-flows/creating-a-strategy';
import entryConditions    from './topics/algo-flows/entry-conditions';
import monitoringExecution from './topics/algo-flows/monitoring-execution';

import whatIsNyx          from './topics/nyx/what-is-nyx';
import preTradeCoaching   from './topics/nyx/pre-trade-coaching';
import analysisMode       from './topics/nyx/analysis-mode';
import stockExplanations  from './topics/nyx/stock-explanations';

import whatIsBacktesting  from './topics/backtesting/what-is-backtesting';
import runningBacktest    from './topics/backtesting/running-a-backtest';
import readingResults     from './topics/backtesting/reading-results';

import tradeAnalysis      from './topics/performance/trade-analysis';
import generatingReport   from './topics/performance/generating-report';
import readingReport      from './topics/performance/reading-report';

export const DOCS_SECTIONS = [
  {
    id: 'getting-started',
    title: 'Getting Started',
    icon: '🚀',
    topics: [whatIsTradeLab, creatingAccount, settingUpProfile, userJourney],
  },
  {
    id: 'platform',
    title: 'The Platform',
    icon: '🖥️',
    topics: [dashboardOverview, navigation, virtualCapital],
  },
  {
    id: 'risk-capital',
    title: 'Risk & Capital',
    icon: '🛡️',
    topics: [riskProfileSetup, riskCapital, positionSizing],
  },
  {
    id: 'discipline',
    title: 'Discipline & Behaviour',
    icon: '🧠',
    topics: [disciplineScore, behavioralProfile, behaviorAnalytics],
  },
  {
    id: 'orders',
    title: 'Orders & Portfolio',
    icon: '📋',
    topics: [placingAnOrder, orderTypes, managingPositions, tradeHistory],
  },
  {
    id: 'act',
    title: 'ACT Practice',
    icon: '⚡',
    topics: [whatIsAct, howScenariosWork, swingVsIntraday, submittingPlan, actScoring],
  },
  {
    id: 'scanners',
    title: 'Scanners',
    icon: '🔍',
    topics: [whatAreScanners, swingScanners, intradayScanners, readingScannerOutput],
  },
  {
    id: 'algo-flows',
    title: 'Algo Flows',
    icon: '⚙️',
    topics: [whatIsAlgoFlows, creatingStrategy, entryConditions, monitoringExecution],
  },
  {
    id: 'nyx',
    title: 'Nyx AI Coach',
    icon: '✨',
    topics: [whatIsNyx, preTradeCoaching, analysisMode, stockExplanations],
  },
  {
    id: 'backtesting',
    title: 'Backtesting',
    icon: '⏪',
    topics: [whatIsBacktesting, runningBacktest, readingResults],
  },
  {
    id: 'performance',
    title: 'Performance & Reports',
    icon: '📊',
    topics: [tradeAnalysis, generatingReport, readingReport],
  },
];

// Flat map for O(1) topic lookup by id
export const DOCS_TOPIC_MAP = DOCS_SECTIONS.reduce((acc, section) => {
  section.topics.forEach(topic => {
    acc[topic.id] = { ...topic, sectionId: section.id, sectionTitle: section.title };
  });
  return acc;
}, {});
